import { Pie } from "@ant-design/plots";
import { Card, Typography } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import Loader from "../../loader/loader";

const { Text } = Typography;

const formatCurrency = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

const SALE_COLOR = "#6366f1";
const PURCHASE_COLOR = "#f59e0b";

const CHART_SIZE = 200;

const SalePurchaseSplit = () => {
  const cardInfo = useSelector((state) => state.dashboard.list?.cardInfo) || {};
  const saleTotal = Number(cardInfo.sale_total) || 0;
  const purchaseTotal = Number(cardInfo.purchase_total) || 0;
  const total = saleTotal + purchaseTotal;
  const salePct = total > 0 ? ((saleTotal / total) * 100).toFixed(1) : "0";
  const purchasePct = total > 0 ? ((purchaseTotal / total) * 100).toFixed(1) : "0";

  const data = [
    { type: "Sales share", value: saleTotal },
    { type: "Purchase share", value: purchaseTotal },
  ].filter((d) => d.value > 0);

  const config = {
    appendPadding: 4,
    data: data.length ? data : [{ type: "No data", value: 1 }],
    angleField: "value",
    colorField: "type",
    color: [SALE_COLOR, PURCHASE_COLOR],
    radius: 0.8,
    innerRadius: 0.58,
    label: false,
    height: CHART_SIZE,
    statistic: {
      title: false,
      content: {
        content: data.length ? `${salePct}%` : "0%",
        style: { fontSize: 18, fontWeight: 600 },
      },
    },
    legend: false,
  };

  return (
    <Card
      title="Sale vs Purchase Split"
      size="small"
      className="dashboard-chart-card dashboard-chart-card-compact dashboard-chart-sale-purchase"
      extra={<Text type="secondary" style={{ fontSize: 12 }}>composition</Text>}
    >
      <div className="sale-purchase-split-wrap">
        <div className="sale-purchase-chart-wrap">
          {cardInfo.sale_total != null ? <Pie {...config} /> : <Loader />}
        </div>
        <div className="sale-purchase-legend">
          <div>
            <Text strong style={{ fontSize: 14 }}>{formatCurrency(saleTotal)}</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 11 }}>{salePct}% of total</Text>
          </div>
          <div>
            <Text strong style={{ fontSize: 14 }}>{formatCurrency(purchaseTotal)}</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 11 }}>{purchasePct}% of total</Text>
          </div>
          <div style={{ display: "flex", gap: 12, marginTop: 4 }}>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <span style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: SALE_COLOR }} />
              <Text type="secondary" style={{ fontSize: 11 }}>Sales</Text>
            </span>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <span style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: PURCHASE_COLOR }} />
              <Text type="secondary" style={{ fontSize: 11 }}>Purchase</Text>
            </span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SalePurchaseSplit;
